import AiaButton from './AiaButton';
import AiaInput from "./AiaInput"
import AiaCard from "./AiaCard"
import AiaCheckbox from "./AiaCheckbox"
import AiaDivider from "./AiaDivider"
import AiaDropDown from "./AiaDropDown"
import AiaDropDownMenu from "./AiaDropDownMenu"
import AiaDropDownItem from "./AiaDropDownItem"
import AiaLink from "./AiaLink"
import AiaMenu from "./AiaMenu"
import AiaSubMenu from "./AiaSubMenu"
import AiaMenuItem from "./AiaMenuItem"
import AiaMenuItemGroup from "./AiaMenuItemGroup"
import AiaTabs from "./AiaTabs"
import AiaTabPane from "./AiaTabPane"
import AiaAlert from "./AiaAlert"
import AiaDialog from "./AiaDialog"
import AiaTable from "./AiaTable"
import AiaTableColumn from "./AiaTableColumn"
import AiaTimeline from "./AiaTimeline"
import AiaTimelineItem from "./AiaTimelineItem"
import AiaRadioGroup from "./AiaRadioGroup"
import AiaRadio from "./AiaRadio"
import AiaSwich from "./AiaSwitch"
const components = [
    AiaButton,
    AiaInput,
    AiaCard,
    AiaCheckbox,
    AiaDivider,
    AiaDropDown,
    AiaDropDownMenu,
    AiaDropDownItem,
    AiaLink,
    AiaMenu,
    AiaSubMenu,
    AiaMenuItem,
    AiaMenuItemGroup,
    AiaTabs,
    AiaTabPane,
    AiaAlert,
    AiaDialog,
    AiaTable,
    AiaTableColumn,
    AiaTimeline,
    AiaTimelineItem,
    AiaRadioGroup,
    AiaRadio

]

const install = function (Vue) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default install
